<mat-form-field appearance="fill">
    <mat-label>{{ _label }}</mat-label>
    <input matInput [matTimepicker]="picker" [(ngModel)]="_time" (ngModelChange)="valueUpdated(_time)" [disabled]="_disabled || _readOnly" [required]="isRequired" [errorStateMatcher]="errorStateMatcher" />
    <mat-timepicker-toggle matIconSuffix [for]="picker"/>
    <mat-timepicker #picker/>
</mat-form-field>
@if (hasError) {
    <div class="error-message">{{ errorMessage }}</div>
}
